
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/single-store",
      function () {
        return require("private-next-pages/sources/single-store.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/single-store"])
      });
    }
  